module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As always, a big, loving thank you to my wonderful husband, Greg, who supports me and works so hard, which allows me to do what I love. And to my beautiful daughter, Tori, who is always patient and understands when Mommy has to work, even if it is at home. I would like to thank all of my fellow RD’s who gave me their expert input and advice on this subject. A special thank you to Jan Patenaude, RD, CLT, who is always such a great sounding-board and someone who can always answer my questions. And thank you to all of the dietitians who took time out of their busy schedules to review my book and provide endorsements."), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f2ecaf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 75
// module chunks = 0